import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import org_api from '../api/admin/admin_orgs'
import org_admin_api from '../api/orgadmin/orgadmin_orgs'
import customer_api from '../api/customer/customer_orgs'
import MainHeader from "../components/MainHeader";
import ValuationAddressSearch from "../components/ValuationSearch/ValuationAddressSearch";
import FinviseValuation from "../components/FinviseValuation";
import InsightValuation from "../components/InsightValuation";
import AddressCurrentValuationHeader from "../components/AddressCurrentValuationHeader";
import val_api from "../api/valuation";
import comparison_api from "../api/comparison";
import GenericDialog from "../components/GenericDialog";
import RICSValuation from "../components/RICSValuation";
import profapi from "../api/profile";
import roles from "../models/Roles";
import fake_property from "../models/FakeProperty";
import pdf_api from "../api/pdf";

const Valuation = () => {
	  const url_params = new URLSearchParams(window.location.search)
	  const org_id = url_params.get('id')

    const FINVISE = 1
    const RICS = 2
    const INSIGHT = 3

	  const [organisation, setOrganisation] = useState()
    const [profile, setProfile] = useState();
    const [addressString, setAddressString] = useState("")
    const [reportType, setReportType] = useState();
    const [clearBar, setClearBar] = useState(false);

    // Report data
    const [requestId, setRequestId] = useState();
    const [valuation, setValuation] = useState();
    const [valuationId, setValuationId] = useState();
    const [summaryId, setSummaryId] = useState();
    const [propertyId, setPropertyId] = useState();
    const [processedDate, setProcessedDate] = useState();
    const [furtherDetails, setFurtherDetails] = useState();
    const [predictedValuation, setPredictedValuation] = useState();
    const [checkAccuracy, setCheckAccuracy] = useState();

    // Report Status
    const [processedReport, setProcessedReport] = useState(false);
    const [processingReport, setProcessingReport] = useState(false)
    const [generatingValuation, setGeneratingValuation] = useState(false)
    const [displayValuation, setDisplayValuation] = useState(false)
    const [insightDataReady, setInsightDataReady] = useState(false);
    const [enableReport, setEnableReport] = useState(false);

    // Error Handling
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [error, setError] = useState("");
    const okButton = [{"text":"OK", "id": "1"}];

    // Credit issue for retail users
    const [showGetCreditBanner, setShowGetCreditBanner] = useState(false);

    const [params] = useSearchParams();
    const [insightParams, setInsightParams] = useState(false)

    useEffect(() => {
        getProfile()
    }, [])

	  const getOrganisation = () => {
	  	if (!profile) return
      let response = null
		  if (profile.role_id === roles.ROLE_ADMIN || profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
	  	  response = org_admin_api.getOrganisation()
      } else {
			  response = customer_api.getOrganisation()
      }
	  	response.then(response => {
	  		if (
	  			response.data.organisations &&
	  			response.data.organisations.length > 0
	  		) {
	  			setOrganisation(response.data.organisations[0])
	  		}
	  	})
	  }

    const getProfile = () => {
        let response = profapi.getProfile();
        response.then(
            response => {
                setProfile(response.data);
            }
        ).catch(err => {
            console.log(err);
            setError("Failed to retrieve profile data");
            setShowErrorDialog(true);
        })
    }

    const updateAccuracy = (property_id) => {
        let response = val_api.valuationAccuracyCheck(property_id);
        response.then(
            response => {
                setCheckAccuracy(response.data.score);
            }
        ).catch(err => {
            console.log(err);
            setError("Unable to check valuation accuracy value");
            setShowErrorDialog(true);
        })
    }

    useEffect(() => {
		    getOrganisation()
        if (!profile) return
        let localStorageValuation= sessionStorage.getItem("in_progress_valuation")
        if (!localStorageValuation) return;
        let localStorageValuation_json = JSON.parse(localStorageValuation)
        // Get values from local storage
        let _property_id = localStorageValuation_json.addr
        let _addr_str = localStorageValuation_json.addr_str
        let _typ = localStorageValuation_json.typ

        // Execute valuation
        evaluate(_property_id, _addr_str, _typ)
        sessionStorage.removeItem("in_progress_valuation")
        if (params.get('id') !== null) {
            let summary_id = params.get('id')
            RecreateInsight(summary_id)
        }
    }, [profile])

    const RecreateInsight = (summary_id) => {
        // Setup
        setReportType(3);
        setProcessedReport(false);
        setDisplayValuation(false)
        setGeneratingValuation(true)

        let response = comparison_api.getOverview(summary_id);
        response.then(response => {
                setValuation(response.data);
                setPropertyId(response.data.property_id)
                let address = response.data.address
                setAddressString((address.paon).replace(" ", ",") + " " +address.saon + " " + address.street + ", " + address.postcode)
                setSummaryId(summary_id)
                setPredictedValuation(response.data.preditcted_valuation)
                setProcessedDate(response.data.processed_date);
                setFurtherDetails(response.data.further_details);
                setDisplayValuation(true)
                setInsightParams(true)
                clearAddress();
                setGeneratingValuation(false)
            }
        ).catch(error => {
            setError("Failed to retrieve insight");
            setShowErrorDialog(true);
            setGeneratingValuation(false)
        })
    }

    const manualEvaluate = (body, addr_str) => {
        if (!profile || !body) return;
        // Setup
        setProcessedReport(false);
        setDisplayValuation(false)
        setGeneratingValuation(true)
        setProcessingReport(true)
        setAddressString(addr_str)
        setReportType(body["type"])
        let response = val_api.postManualValuation(body)
        response.then(response => {
            if (body["type"] === RICS) { // Must be ==
                setDisplayValuation(true)
                setInsightParams(false)
                clearAddress();
                setGeneratingValuation(false)
            }
            else {
                setRequestId(response.data.request_id)
            }
        }).catch(error => {
                if (error.response.data && error.response.data.description){
                    if (profile.role_id === roles.ROLE_RETAIL_USER &&
                        error.response.data.description.includes("Insufficient credits")){
                        // Add values for current valuation into session storage if insufficient credits
                        sessionStorage.setItem("in_progress_valuation", JSON.stringify({"addr": 0, "addr_str": addr_str, "typ": 2}));
                        // Render the page with no data
                        let data = fake_property.valuation_data(0)
                        setValuation(data.valuation);
                        setValuationId(data.valuation.id);
                        setPredictedValuation(data.valuation.predicted_value);
                        setProcessedDate(data.processed_date);
                        setFurtherDetails(data.valuation.further_details);
                        setDisplayValuation(true);
                        clearAddress();
                        setGeneratingValuation(false);
                        setShowGetCreditBanner(true);
                        setProcessingReport(false)
                    }
                    else {
                        setError(error.response.data.description);
                        setShowErrorDialog(true);
                        setGeneratingValuation(false)
                        setProcessingReport(false)
                        clearAddress();
                    }
                }
                else {
                    setError("Failed to retrieve valuation");
                    setShowErrorDialog(true);
                    setGeneratingValuation(false)
                    setProcessingReport(false)
                }
            }
        )
    }

    const evaluate = (_body, addr_str) => {
        if (!_body || !profile) return;
        // Setup
        setProcessedReport(false);
        setDisplayValuation(false)
        setGeneratingValuation(true)
        setProcessingReport(true)
        setAddressString(addr_str)
        setReportType(_body["type"])
        // Get Report
        let response = val_api.postValuation(_body);
        response.then(response => {
            if (_body["type"] === RICS) { // Must be ==
                console.log(_body["type"])
                console.log('RICS')
                setDisplayValuation(true)
                setInsightParams(false)
                clearAddress();
                setGeneratingValuation(false)
            }
            else {
                setRequestId(response.data.request_id)
            }
        }).catch(error => {
            console.log(error)
                if (error.response.data && error.response.data.description) {
                    if (profile.role_id === roles.ROLE_RETAIL_USER &&
                        error.response.data.description.includes("Insufficient credits")){

                        // Add values for current valuation into session storage if insufficient credits
                        sessionStorage.setItem("in_progress_valuation", JSON.stringify({
                            "addr": _body && _body.property_id,
                            "addr_str": addr_str,
                            "typ": _body && _body.type
                        }));

                        // Render the page with no data if has property_id otherwise through error message saying insufficient credits
                        if (_body && _body.property_id) {
                            let data = fake_property.valuation_data(_body.property_id)
                            setValuation(data.valuation);
                            setValuationId(data.valuation.id);
                            setPredictedValuation(data.valuation.predicted_value);
                            setProcessedDate(data.processed_date);
                            setFurtherDetails(data.valuation.further_details);
                            setDisplayValuation(true);
                            clearAddress();
                            setGeneratingValuation(false);
                            updateAccuracy(_body.property_id);
                            setShowGetCreditBanner(true);
                            setProcessingReport(false)
                        }
                        else {
                            setError("Insufficient credits");
                            setShowErrorDialog(true);
                            setGeneratingValuation(false)
                            setProcessingReport(false)
                            clearAddress();
                        }
                    }
                    else {
                        setError(error.response.data.description);
                        setShowErrorDialog(true);
                        setGeneratingValuation(false)
                        setProcessingReport(false)
                        clearAddress();
                    }
                }
                else {
                    setError("Failed to retrieve valuation");
                    setShowErrorDialog(true);
                    setGeneratingValuation(false)
                    setProcessingReport(false)
                }
            }
        )

    }

    useEffect(() => {
        if (!requestId) return;
        checkRequestStatus()
    }, [requestId]);

    const checkRequestStatus = () => {
        if (!requestId) return
        // Get Report
        let response = val_api.checkValuationRequest(requestId);
        response.then(response => {

                if (response.data.error_message) {
                    setError("Failed to retrieve valuation");
                    setShowErrorDialog(true);
                    setGeneratingValuation(false)
                    setProcessingReport(false)
                }
                else if (response.data.repoll) {
                    setTimeout(checkRequestStatus, 5000);
                }
                else {
                    setValuation(response.data.valuation);
                    setValuationId(response.data.report_guid);
                    setSummaryId(response.data.valuation_summary_id)
                    setPredictedValuation(response.data.preditcted_valuation)
                    setProcessedDate(response.data.processed_date);
                    setFurtherDetails(response.data.valuation.further_details);
                    setReportType(response.data.valuation_type.id)
                    setPropertyId(response.data.valuation.property_id)
                    setDisplayValuation(true)
                    setInsightParams(false)
                    clearAddress();
                    setGeneratingValuation(false)
                }
            }
        ).catch(error => {
            console.log(error)
        })
    }

    const handleOKDialogResult = (res) => {
        setShowErrorDialog(false);
    }

    const closeReport = () => {
        setValuation(null);
        setProcessedReport(false);
        setDisplayValuation(false);
        setInsightDataReady(false);
        setEnableReport(false);
        setRequestId(null)
        setGeneratingValuation(false)
        clearAddress();
    }

    const clearAddress = () => {
        // Prepare state for next request
        setClearBar(true);
        setInsightDataReady(false);
        setEnableReport(false);
    }

    const updateInsightDataReady = () => {
        setInsightDataReady(true);
        let body = {
            "property_id": propertyId,
            "summary_id": summaryId,
            "report_type": 3
        }
        let response = pdf_api.processReport(body);
        response.then(
            response => {
                setEnableReport(true);
                setProcessingReport(false);
            }
        ).catch(err => {
            console.log(err);
            setError("Processing report failure");
            setShowErrorDialog(true);
            setProcessingReport(false);
            setEnableReport(false);
        })
    }

    return (
        <>
            <MainHeader />
            <div className="valuation-page-container">
                <div className="valuation-container">
                    <ValuationAddressSearch
                      evaluate={evaluate.bind(this)}
                      manualEvaluate={manualEvaluate.bind(this)}
                      clearBar={clearBar}
                      setClearBar={setClearBar}
                      organisation={organisation}
                    />
                    <div className="valuation-content-container">
                        {displayValuation || generatingValuation
                            ? <AddressCurrentValuationHeader addressString={addressString}
                                                             close={closeReport.bind(this)}
                                                             reportType={reportType}
                                                             processingReport={processingReport}
                                                             enableReport={enableReport}
                                                             summaryId={summaryId}/>
                            : null }
                        {generatingValuation && generatingValuation ?
                            <div className="loading-valuation-container">
                                <div className="valuation-result-container">
                                    <div className="loading-valuation-text">
                                        {
                                            reportType && reportType === RICS
                                                ? "We are preparing your report"
                                                : "We’re preparing your valuation - this may take up to 2 minutes."
                                        }
                                    </div>
                                    <div className="valuation-loading-bar-container">
                                        <div className="valuation-loading-bar-bouncer" />
                                    </div>
                                </div>
                            </div>
                            : null}
                        {displayValuation && displayValuation
                            ?
                            <>
                            {reportType === FINVISE
                                ? <FinviseValuation valuation={valuation}
                                                    valuationId={summaryId}
                                                    processedDate={processedDate}
                                                    furtherDetails={furtherDetails}
                                                    setError={setError.bind(this)}
                                                    setShowErrorDialog={setShowErrorDialog.bind(this)}/>
                                : (reportType === RICS)
                                    ? <RICSValuation valuation={valuation}
                                                     valuationId={summaryId}
                                                     processedDate={processedDate}
                                                     furtherDetails={furtherDetails}
                                                     setError={setError.bind(this)}
                                                     setShowErrorDialog={setShowErrorDialog.bind(this)}/>
                                    : (reportType === INSIGHT)
                                        ? <InsightValuation valuation={valuation}
                                                            valuationId={summaryId}
                                                            addressString={addressString}
                                                            propertyId={propertyId}
                                                            summaryId={summaryId}
                                                            predicted_valuation={predictedValuation}
                                                            processedDate={processedDate}
                                                            furtherDetails={furtherDetails}
                                                            params={insightParams}
                                                            setError={setError.bind(this)}
                                                            setShowErrorDialog={setShowErrorDialog.bind(this)}
                                                            showCreditBanner={showGetCreditBanner}
                                                            check_accuracy={checkAccuracy}
                                                            dataReady={insightDataReady}
                                                            updateInsightDataReady={updateInsightDataReady.bind(this)}/>
                                        : null}
                                </>
                                : null}
                    </div>
                </div>
            </div>

            {showErrorDialog
                ? <GenericDialog title="Valuation - Error" text={error} buttons={okButton}
                                 result={handleOKDialogResult.bind(this)} />
                : null
            }
        </>
    )
}

export default Valuation
